import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { selectCurrentUser } from '../../../current-user/store/current-user.selectors';
import { inputIsNotNullOrUndefined } from '../../../data-access/input-is-not-null-or-undefined';
import { UserTypes } from '../../../users/user.types';
import { CurrentUser } from '../../../data-access/users';
import { environment } from '../../../../environments/environment';
import { getFunctionUrl } from 'src/app/utils/get-function-url';
import type { Integration, IntegrationModel, IntegrationSettings, IntegrationType } from '../../../models/integration-settings';

const INTEGRATIONS_SETTINGS: { [type in IntegrationType]: IntegrationSettings } = environment.integrationSettings;

const getIntegrationRoles = (currentUser: CurrentUser, integration: IntegrationModel): number[] => {
  if (integration.type === 'zapier') {
    return [ UserTypes.OWNER ];
  }
  return currentUser.type === UserTypes.OWNER ? [ UserTypes.OWNER, UserTypes.LEAD, UserTypes.INSIDE_SALES, UserTypes.USER ] : currentUser.type === UserTypes.LEAD ? [ UserTypes.LEAD, UserTypes.USER ] : [ UserTypes.USER ];
};

@Injectable({
  providedIn: 'root',
})
export class GetIntegrationsService {
  private readonly http = inject(HttpClient);
  private readonly store$ = inject(Store);

  get(): Observable<Integration[]> {
    return this.store$.pipe(
      select(selectCurrentUser),
      filter(inputIsNotNullOrUndefined),
      take(1),
      switchMap(currentUser =>
        this.http.get<IntegrationModel[]>(`${ getFunctionUrl(environment.urls.functions.v2, 'integrationsapiv2') }/`).pipe(
          map(integrations =>
            integrations.map(integration => ({
              ...integration,
              roles: getIntegrationRoles(currentUser, integration),
              ...INTEGRATIONS_SETTINGS[integration.type],
            }))
          ),
        )
      ),
    );
  }
}
